<script>
    export let visible = false;
</script>

<div class="modal" class:visible>
    <div class="modalContent">
        <slot></slot>
    </div>
</div>

<style>
    .modal {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        margin: 0;
        overflow: auto;
    }

    .modalContent {
        position: absolute;
        top: 50%;
        left: 50%;
        width: -moz-fit-content;
        width: fit-content;
        transform: translate(-50%, -50%);
        background-color: #eee;
        padding: 20px;
        box-shadow: 0 0 10px -2px black;
    }

    .visible {
        display: block;
    }
</style>